import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import Logo from "./../../assets/Images/cold-core.png";
import HeaderImage from "../../assets/Images/ammonia-header.jpg";
import FooterImage from "../../assets/Images/ammonia-footer.jpg";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Times-Roman",
    position: "relative",
  },
  logo: {
    width: 100,
    height: 80,
    marginLeft: 10,
  },
  section: {
    marginBottom: 8,
  },
  textBold: {
    fontWeight: "bold",
    fontFamily: "Times-Bold",
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    marginTop: 10,
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    padding: 5,
  },
  tableHeader: {
    fontWeight: "bold",
    backgroundColor: "#f0f0f0",
    textAlign: "center",
  },
  watermark: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(-45deg)",
    fontSize: 48,
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.1)",
    zIndex: -1,
    pointerEvents: "none",
  },
  footer: {
    marginTop: 20,
  },
  headerContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  headerText: {
    textAlign: "left",
  },
  companyName: {
    fontSize: 30,
    fontWeight: "bold",
    marginBottom: 6,
    fontFamily: "Times-Bold",
  },
  allTemp: {
    color: "blue",
  },
  refrigeration: {
    color: "blue",
  },
  equipmentText: {
    fontSize: 12,
    marginBottom: 0,
    fontFamily: "Times-Roman",
  },
  totalChargeSection: {
    marginTop: 0,
    marginBottom: 10,
  },
  boldValue: {
    fontWeight: "bold",
    fontSize: 12,
    fontFamily: "Times-Bold",
  },
  sincerely: {
    marginBottom: 15,
  },
  equipmentList: {
    marginBottom: 0,
  },
  sectionTitle: {
    fontWeight: "bold",
    textDecoration: "underline",
    marginBottom: 10,
    fontFamily: "Times-Bold",
  },
  textBoldUnderline: {
    fontWeight: "bold",
    textDecoration: "underline",
    fontFamily: "Times-Bold",
  },
  headerImage: {
    width: "100%",
    height: 80,
    resizeMode: "cover",
    marginBottom: "50px",
  },
  footerImage: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: 80,
    resizeMode: "cover",
  },
  normalText: {
    fontSize: 12,
    fontFamily: "Times-Roman",
  },
  equipmentRow: {
    flexDirection: "row",
    marginBottom: 4,
    alignItems: "center",
  },
  equipmentName: {
    width: "60%",
    flexDirection: "row",
    alignItems: "center",
  },
  dots: {
    flexGrow: 1,
    borderBottomWidth: 1,
    borderBottomStyle: "dotted",
    borderColor: "black",
    marginLeft: 4,
    marginRight: 4,
    height: 12, // Ensure consistent height for dots
  },
  equipmentValue: {
    width: "40%",
    textAlign: "left",
    paddingLeft: 10,
  },
  totalChargeRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 8,
    marginTop: 8,
    marginBottom: 15,
  },
  totalEquimentChargeRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 8,
    marginTop: 8,
    marginBottom: 0,
  },
  totalPipeChargeRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 0,
    marginTop: 8,
    marginBottom: 15,
  },
  totalChargeLabel: {
    width: "60%",
    flexDirection: "row",
    alignItems: "center",
    fontFamily: "Times-Bold",
  },
  totalChargeValue: {
    width: "40%",
    textAlign: "left",
    fontFamily: "Times-Bold",
    paddingLeft: 10,
  },
  line: {
    borderTopWidth: 1,
    borderTopColor: "#000",
    marginTop: 10,
    marginBottom: 10,
  },
});

const AmmoniaInventoryPDF = (report) => {
  console.log("report", report);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

const formatNumberWithCommas = (number) => {
  if (number === null || number === undefined || isNaN(number)) {
    return "0.00";
  }
  return Number(number).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image src={HeaderImage} style={styles.headerImage} />

        <View style={styles.section}>
          <Text style={styles.textBold}>
            Document ID: {report.data.documentId}
          </Text>
          <Text style={styles.normalText}>{formatDate(Date.now())}</Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.textBold}>{report.data.customer}</Text>
          <Text style={styles.normalText}>{report.data.location}</Text>
        </View>

        <View style={styles.section}>
          <Text style={[styles.sectionTitle, styles.textBoldUnderline]}>
            RE: Ammonia Charge Estimation
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.normalText}>
						We have reviewed your ammonia refrigeration system for system charge estimation. We have documented the
						sizes of vessels, condensers, evaporators, compressors and piping their operating temperatures and their
						ammonia capacties at operating temperature.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.textBold}>
            Based on the provided information, the estimated ammonia charge is:
          </Text>
        </View>

        <View style={[styles.section, { marginBottom: 10 }]}>
          {report.data?.chargeCapacities?.map((eq, index) => (
            <View key={index} style={styles.equipmentRow}>
              <View style={styles.equipmentName}>
                <Text style={styles.equipmentText}>
                  {eq.equipmentName} x {eq.numberOfUnits || 0}{" "}
                </Text>
                <View style={styles.dots} />
              </View>
              <Text style={[styles.equipmentText, styles.equipmentValue]}>
                {formatNumberWithCommas(eq.totalCapacity)} lbs
              </Text>
            </View>
          ))}
        </View>

        <View style={styles.totalEquimentChargeRow}>
          <View style={styles.totalChargeLabel}>
            <Text>Total Estimated Ammonia Charge for Equipments</Text>
            <View style={styles.dots} />
          </View>
          <Text style={styles.totalChargeValue}>
            {formatNumberWithCommas(report.data?.estimatedEquipmentCharge)} lbs
          </Text>
        </View>
        <View style={styles.totalPipeChargeRow}>
          <View style={styles.totalChargeLabel}>
            <Text>Total Estimated Ammonia Charge for Pipes</Text>
            <View style={styles.dots} />
          </View>

          <Text style={styles.totalChargeValue}>
            {formatNumberWithCommas(report.pipesData.totalCapacity)} lbs
          </Text>
        </View>
        <View style={styles.totalChargeRow}>
          <View style={styles.totalChargeLabel}>
            <Text>Total Estimated Ammonia Charge for Equipments and Pipes</Text>
            <View style={styles.dots} />
          </View>

          <Text style={styles.totalChargeValue}>
            {formatNumberWithCommas(report.data?.estimatedCharge)} lbs
          </Text>
        </View>

        <Text style={styles.normalText}>
          This estimation was based on the ambient and operating conditions on{" "}
          {formatDate(report.data.dateOfService)}. The estimation calculations
          will give you accuracy within{" "}
          <Text style={styles.boldValue}>+/- {report.data.accuracy}%</Text>{" "}
          which ranges from low estimation of{" "}
          <Text style={styles.boldValue}>
            {formatNumberWithCommas(Math.round(report.data.lowEstimation))} lbs
          </Text>{" "}
          to a high estimation of{" "}
          <Text style={styles.boldValue}>
            {formatNumberWithCommas(Math.round(report.data.highEstimation))}{" "}
            lbs.
          </Text>
        </Text>

        <View style={styles.footer}>
          <Text style={styles.sincerely}>Sincerely,</Text>
          <Text>
            <Text style={styles.allTemp}>
              Senior Vice President Of Operations
            </Text>
          </Text>
          <Text>
            <Text style={styles.allTemp}>Cold Core Group </Text>
          </Text>
          <Text style={styles.refrigeration}>Phone: (262) 781-5757</Text>
          <Text style={styles.refrigeration}>
            Email: {process.env.PARTNER_ENQUIRY_TO_EMAIL}
          </Text>
        </View>

        <Image src={FooterImage} style={styles.footerImage} />
      </Page>
    </Document>
  );
};

export default AmmoniaInventoryPDF;
